import { render, staticRenderFns } from "./CheckboxView.vue?vue&type=template&id=c0c3ac88&scoped=true"
import script from "./CheckboxView.vue?vue&type=script&lang=js"
export * from "./CheckboxView.vue?vue&type=script&lang=js"
import style0 from "./CheckboxView.vue?vue&type=style&index=0&id=c0c3ac88&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0c3ac88",
  null
  
)

export default component.exports